import { isAxiosError } from 'axios';
import { axiosAuth } from '@/axios';
import { Endpoints } from '@/enums';
import { NewPasswordData } from '@/types/auth';

export const activateUser = async (
  newPasswordData: NewPasswordData
): Promise<unknown> => {
  try {
    const res = await axiosAuth.post(Endpoints.ActivateUser, {
      ...newPasswordData,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
